import { Link } from "react-router-dom";

const statusStyles = {
  available: "bg-sage text-white",
  reserved: "bg-terracotta text-white",
  sold: "bg-bark text-cream",
};

export const RabbitCard = ({ rabbit, idx = 0 }) => {
  const tilt = idx % 2 === 0 ? "lg:translate-y-0" : "lg:translate-y-8";
  return (
    <Link
      to={`/rabbits/${rabbit.id}`}
      data-testid={`rabbit-card-${rabbit.id}`}
      className={`group block ${tilt}`}
    >
      <div className="overflow-hidden border border-border bg-white transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgba(200,106,83,0.12)]">
        <div className="relative aspect-[4/5] overflow-hidden bg-muted">
          {rabbit.image_url ? (
            <img
              src={rabbit.image_url}
              alt={rabbit.name}
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              loading="lazy"
            />
          ) : (
            <div className="flex h-full items-center justify-center text-stone">No photo</div>
          )}
          <span
            className={`absolute left-4 top-4 px-3 py-1 text-[10px] uppercase tracking-[0.2em] ${
              statusStyles[rabbit.status] || statusStyles.available
            }`}
            data-testid={`rabbit-status-${rabbit.id}`}
          >
            {rabbit.status}
          </span>
        </div>
        <div className="flex items-end justify-between gap-4 p-6">
          <div>
            <div className="section-label">{rabbit.sex} · {rabbit.color}</div>
            <h3 className="mt-2 font-serif text-3xl leading-none text-foreground">{rabbit.name}</h3>
          </div>
          <div className="text-right">
            <div className="font-serif text-2xl text-terracotta">${rabbit.price?.toFixed(0)}</div>
            <div className="text-xs text-stone">View details →</div>
          </div>
        </div>
      </div>
    </Link>
  );
};
